/**
 * Minimal ABI for FairLaunchFactory.sol — only the entries the frontend needs.
 *
 * Generated from the compiled artifact at:
 *   contracts-fair-launch/artifacts/contracts/FairLaunchFactory.sol/FairLaunchFactory.json
 *
 * Keep in sync with the deployed contract. When Task #6 redeploys the USD oracle
 * model, verify this ABI still matches (the public signatures are unchanged).
 */
export const fairLaunchFactoryAbi = [
  // ── State reads ────────────────────────────────────────────────────────────
  {
    name: "creationFee",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
  },
  {
    name: "feeExempt",
    type: "function",
    stateMutability: "view",
    inputs: [{ name: "", type: "address" }],
    outputs: [{ name: "", type: "bool" }],
  },
  {
    name: "buyFeeBps",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
  },
  {
    name: "sellFeeBps",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
  },
  {
    name: "priceOracle",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "address" }],
  },
  {
    name: "fallbackOraclePrice",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
  },
  {
    name: "oracleStalenessThreshold",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
  },
  {
    name: "oracleDecimals",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "uint8" }],
  },

  // ── Write ──────────────────────────────────────────────────────────────────
  {
    name: "createFairLaunch",
    type: "function",
    stateMutability: "payable",
    inputs: [
      { name: "name",   type: "string" },
      { name: "symbol", type: "string" },
    ],
    outputs: [
      { name: "token",  type: "address" },
      { name: "market", type: "address" },
    ],
  },

  // ── Events ─────────────────────────────────────────────────────────────────
  {
    name: "FairLaunchCreated",
    type: "event",
    inputs: [
      { name: "token",           type: "address", indexed: true  },
      { name: "market",          type: "address", indexed: true  },
      { name: "creator",         type: "address", indexed: true  },
      { name: "name",            type: "string",  indexed: false },
      { name: "symbol",          type: "string",  indexed: false },
      { name: "creationFeePaid", type: "uint256", indexed: false },
      { name: "timestamp",       type: "uint256", indexed: false },
    ],
  },
] as const;
